import React, { ReactElement, useEffect } from 'react';
import cx from 'classnames';
import classes from './split_content.module.scss';

export type HeroProps = {
    children?: ReactElement,
    className?: string,
    background?: { colour: string },
    style?: React.CSSProperties,
}

const Header = (props: HeroProps) => {  

    const _classes = cx(classes['split-content'], {
        [classes[`bg-${props.background?.colour}`]]: props.background?.colour,
    }, props.className);


    useEffect(() => {

    }, [])

    return (
        <div className={_classes}>
            {props.children}
        </div>
    )
}

export default Header;